import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";

const CustomNoRowsOverlay = ({
  text = "We couldn't find any records matching your criteria.",
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      minHeight="250px"
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          backgroundColor:
            theme.palette.mode === "dark"
              ? "rgba(255,255,255,0.03)"
              : "rgba(0,0,0,0.03)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2,
          boxShadow:
            theme.palette.mode === "dark"
              ? "inset 0 2px 10px rgba(0,0,0,0.2)"
              : "inset 0 2px 10px rgba(0,0,0,0.05)",
        }}
      >
        <SearchOffOutlinedIcon
          sx={{
            fontSize: 32,
            color:
              theme.palette.mode === "dark"
                ? colors.blueAccent[500]
                : colors.blueAccent[400],
          }}
        />
      </Box>
      <Typography
        color={colors.gray[100]}
        variant="h5"
        fontWeight="600"
        mb="4px"
      >
        No results found
      </Typography>
      <Typography color={colors.gray[400]} variant="body2" textAlign="center">
        {typeof text === "string"
          ? text
          : "We couldn't find any records matching your criteria."}
      </Typography>
    </Box>
  );
};

export default CustomNoRowsOverlay;
